<template>
  <div id="app">
    <el-header>
      <div class="logo">
        <img mode="aspectFill" src="./assets/img/toplogo.png" alt />
      </div>
      <p class="logo-name">MINIPIKA  时光之城</p>
    </el-header>
    <el-main>
      <router-view />
    </el-main>
    <div class="footer" v-show="true">
      <p class="footer-title">MINIPIKA 时光之城</p>
      <div class="footer-content" id="footer-coontent">
        <div class="footer-content-nav">
          <a href="javascript: void(0)" @click="goto('/about', 'video')" class="footer-content-nav-title">关于我们</a>
          <a href="javascript: void(0)" @click="goto('/about', 'video')" class="footer-content-nav-content" >品牌简介</a>
          <a href="javascript: void(0)" @click="goto('/about', 'explain')" class="footer-content-nav-content">品牌含义</a>
          <a href="javascript: void(0)" @click="goto('/about', 'idea')" class="footer-content-nav-content">品牌理念</a>
          <a href="javascript: void(0)" @click="goto('/about', 'vision')" class="footer-content-nav-content">品牌愿景</a>
          <a href="javascript: void(0)" @click="goto('/about', 'story')" class="footer-content-nav-content">品牌故事</a>
        </div>
        <div class="footer-content-nav">
          <a href="javascript: void(0)" @click="goto('/product', 'product-0')" class="footer-content-nav-title">产品</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-1')" class="footer-content-nav-content">胶原棒</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-2')" class="footer-content-nav-content">胶原水</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-3')" class="footer-content-nav-content">胶原精华</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-4')" class="footer-content-nav-content">胶原面霜</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-5')" class="footer-content-nav-content">胶原面膜</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-6')" class="footer-content-nav-content">胶原眼精华</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-7')" class="footer-content-nav-content">广藿香面霜</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-8')" class="footer-content-nav-content">水光弹面膜</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-9')" class="footer-content-nav-content">姜根养发套装</a>
          <a href="javascript: void(0)" @click="goto('/product', 'product-10')" class="footer-content-nav-content">姜根养发旅行装</a>
        </div>
        <div class="footer-content-nav">
          <a href="javascript: void(0)" @click="goto('/study', 'study-0')" class="footer-content-nav-title">科研</a>
          <a href="javascript: void(0)" @click="goto('/study', 'study-1')" class="footer-content-nav-content">专利技术</a>
          <a href="javascript: void(0)" @click="goto('/study', 'study-1')" class="footer-content-nav-content">权威认证</a>
        </div>
        <div class="footer-content-nav">
          <a href="javascript: void(0)" @click="goto('/news', 'news-1')" class="footer-content-nav-title">新闻资讯</a>
          <a href="javascript: void(0)" @click="goto('/news', 'news-1')" class="footer-content-nav-content">企业资讯</a>
          <a href="javascript: void(0)" @click="goto('/news', 'news-2')" class="footer-content-nav-content">行业动态</a>
          <a href="javascript: void(0)" @click="goto('/news', 'news-3')" class="footer-content-nav-content">品牌动态</a>
        </div>
        <div class="footer-content-nav">
          <a href="javascript: void(0)" @click="goto('/service', 'service-1')" class="footer-content-nav-title">服务中心</a>
          <a href="javascript: void(0)" @click="goto('/service', 'service-1')" class="footer-content-nav-content">品牌防伪查询</a>
          <a href="javascript: void(0)" @click="goto('/service', 'service-2')" class="footer-content-nav-content">入驻门店地址</a>
          <a href="javascript: void(0)" @click="goto('/service', 'service-3')" class="footer-content-nav-content">全国售后服务</a>
        </div>
        <div class="footer-content-nav">
          <a href="javascript: void(0)" @click="goto('/ways', 'ways-1')" class="footer-content-nav-title">玩转MINIPIKA</a>
          <a href="javascript: void(0)" @click="goto('/ways', 'ways-1')" class="footer-content-nav-content">品牌故事</a>
          <a href="javascript: void(0)" @click="goto('/ways', 'ways-2')" class="footer-content-nav-content">玩转攻略</a>
        </div>
        <div class="footer-content-nav">
          <p class="footer-content-nav-title">联系我们</p>
          <p class="footer-content-nav-address">地址：广州市番禺区南村镇汉溪大道东</p>
          <p class="footer-content-nav-address">390号四海城商业广场3栋13A05</p>
          <p class="footer-content-nav-address">(广州时光之城科技有限公司)</p>
          <div class="footer-content-nav-address-none"></div>
          <p class="footer-content-nav-address">全国售后服务热线： </p>
          <p class="footer-content-nav-address">020-84820743</p>
          <div class="footer-content-nav-icon-content">
            <img @click="openTab('https://5vh8fuf02k4ag3mu323-xxvivmagiv.taobao.com/shop/view_shop.htm?spm=a21n57.1.5.1.4f1a523caXa5dJ&appUid=RAzN8HWYES2HWT7pNioeAfLMYQG4QDBoRb19w4uvoEeGCs9Fqjg')" mode="aspectFill" class="footer-content-nav-icon-content-img" src="./assets/img/taobao.png" />
            <img @click="openTab('https://www.douyin.com/user/MS4wLjABAAAA5U41_K9br0W0DGtL6kci_QzyRFtxSumiPbCuvCg8pvU?from_tab_name=main')" mode="aspectFill" class="footer-content-nav-icon-content-img" src="./assets/img/douyin.png" />
            <img @click="openTab('https://weibo.com/7723617067?refer_flag=1001030103_')" mode="aspectFill" class="footer-content-nav-icon-content-img" src="./assets/img/weibo.png" />
            <img mode="aspectFill" class="footer-content-nav-icon-content-img" src="./assets/img/weixin.png" />
            <img @click="openTab('https://www.xiaohongshu.com/user/profile/60a6274800000000010022c6')" mode="aspectFill" class="footer-content-nav-icon-content-img" src="./assets/img/hongshu.png" />
          </div>
          <img mode="aspectFill" class="footer-content-nav-qr" src="./assets/img/qr.png" />
        </div>
      </div>
      <img v-if="!scrollRight" mode="aspectFill" class="footer-arrow" src="./assets/img/footer-arrow.png" />
    </div>
  </div>
</template>

<script>
import { jump } from '@/util';
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      scrollRight: false,
    };
  },
  mounted() {
    const footerDiv = document.getElementById('footer-coontent');
    const that = this
    footerDiv.onscroll = function() {
      if (footerDiv.scrollLeft + footerDiv.clientWidth + 10 >= footerDiv.scrollWidth) {
        that.scrollRight = true
      } else {
        that.scrollRight = false
      }
    }
  },
  methods: {
    goto(path, anchor) {
      if (this.$route.path === path) {
        if (anchor) {
          const e = document.getElementById(anchor)
          e.scrollIntoView()
        }
      } else {
        this.$router.push({path, hash: anchor})
      }
    },
    openTab(path) {
      jump(null, path)
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  width: 100vw;
  max-width: 100%;
  background-color: white;
}

a {
  text-decoration: none;
}

::-webkit-scrollbar {
  display: none;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  min-height: 100vh;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.el-header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  height: 0.8rem !important;
  background-color: #fff;
  padding: 0 !important;
  position: relative;
  .logo {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 0.56rem;
    left: 0.6rem;
    width: 1.344rem;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
  .logo-name {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 0.28rem;
    color: #3D3D3D;
    line-height: 0.48rem;
  }
}
.el-main {
  padding: 0 !important;
  width: 100%;
  flex: none !important;
}

.footer {
  position: relative;
  width: 100%;
  height: 4rem;
  z-index: 5;
  overflow: hidden;
  box-sizing: border-box;
  background: linear-gradient( 180deg, #4D3899 0%, #534587 100%);
  &-title {
    margin-top: 0.26rem;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 500;
    font-size: 0.26rem;
    color: #FFFFFF;
    line-height: 0.36rem;
    text-align: center;
    word-break: keep-all;
  }
  &-content {
    margin: 0;
    width: 100%;
    margin-top: 0.33rem;
    padding-left: 0.68rem;
    padding-right: 0.68rem;
    box-sizing: border-box;
    overflow-x: scroll;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    column-gap: 0.68rem;
    &-nav {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      &-title {
        margin-bottom: 0.2rem;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 500;
        font-size: 0.2rem;
        color: #FFFFFF;
        line-height: 0.24rem;
        text-align: left;
        word-break: keep-all;
      }
      &-content {
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 0.16rem;
        color: #FFFFFF;
        line-height: 0.24rem;
        text-align: left;
        word-break: keep-all;
      }
      &-address {
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 0.1rem;
        color: #FFFFFF;
        line-height: 0.2rem;
        word-break: keep-all;
        &-none {
          height: 0.17rem;
        }
      }
      &-icon-content {
        margin-top: 0.08rem;
        display: flex;
        align-items: center;
        column-gap: 0.08rem;
        &-img {
          width: 0.16rem;
          height: 0.16rem;
        }
      }
      &-qr {
        margin-top: 0.02rem;
        margin-left: 0.54rem;
        width: 0.52rem;
        height: 0.59rem;
      }
    }
  }
  &-arrow {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.5rem;
    height: 0.25rem;
  }
}
</style>
